/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Fragment } from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import { Typography } from '@material-ui/core';
import { formatLocDateMMDDYYYY } from '@mummssoftware/utils/formatters';
import { doNotDisplayText, getReadOnlyInputText, isSubqchoice, updateStructure } from '@mummssoftware/utils/form-engine/form-engine-utils';
import { PainMapReadOnly } from './PainMapReadOnly';
import { FormSignature } from './FormSignature';
/**
 * FORMS SPECIFIC ELEMENTS
 */

import { horizontal, statement, label, input, date, signature, singleselect, multiselect, map } from './constants';
import { FormBody, StyledLi, StyledReadOnlyUl, DCDiv, FormLi, StyledDiv, InputDiv, ElementDiv } from './WrapperDiv';
import { useStyles } from './style';
import { ReadLabelField, ReadOnlyStatementField } from './Field';
import { renderTaggedNotes } from '../style/ThemeProvider/taggedNote';
import { updateWhoStructure, getReadOnlySelectText, createGolbalLabelState, cleanFormSubmission } from './utils';

var _ref = /*#__PURE__*/React.createElement("div", null, "Error displaying Form");

export const ReadOnlyForm = ({
  formData,
  pnNotes,
  title,
  printView,
  dialogHeight
}) => {
  const classes = useStyles();
  const readOnlyData = cleanFormSubmission(formData);
  let parsedData; // catch JSON parse exceptions

  try {
    parsedData = readOnlyData && JSON.parse(readOnlyData);
  } catch (e) {
    // TODO alert
    console.log('JSON PARSING ERROR', e);
  }

  const updateddata = parsedData && parsedData[0] ? updateStructure(parsedData) : undefined;
  const updatedData = updateddata && updateddata[0] ? updateWhoStructure(updateddata) : undefined; // console.log('***ReadOnlyForm updatedData***', updatedData);
  // this is for the goal will be achieved within

  const labelState = updatedData && createGolbalLabelState(updatedData); // @note empty Read Only are updatedData = [null]

  const renderField = (subqchoice, subMenu // eslint-disable-next-line consistent-return
  ) => {
    switch (subqchoice.controltype) {
      case label:
        return /*#__PURE__*/React.createElement("div", {
          key: `label-${subqchoice.id}-${subqchoice.questionpath}`,
          id: "read-only-label"
        }, /*#__PURE__*/React.createElement(FormLi, {
          key: `li-${subqchoice.id}-${subqchoice.questionpath}`,
          horizontal: subqchoice.drawmode === horizontal
        }, /*#__PURE__*/React.createElement(ReadLabelField, {
          key: `field-${subqchoice.id}-${subqchoice.questionpath}`,
          subqchoice: subqchoice,
          isExpanded: isSubqchoice(subqchoice)
        }), subMenu));

      case input:
        return /*#__PURE__*/React.createElement(InputDiv, {
          key: `input-${subqchoice.id}-${subqchoice.questionpath}`,
          id: "read-only-input"
        }, /*#__PURE__*/React.createElement(StyledDiv, {
          key: `li-${subqchoice.id}-${subqchoice.questionpath}`
        }, doNotDisplayText(subqchoice) ? '' : getReadOnlyInputText(subqchoice), subMenu));

      case singleselect:
      case multiselect:
        {
          return subqchoice.overwritedrawmode ? /*#__PURE__*/React.createElement("div", {
            key: `checkbox-${subqchoice.parentquestionpath}-${subqchoice.id}`,
            id: "read-only-select"
          }, /*#__PURE__*/React.createElement(StyledLi, {
            key: `li-${subqchoice.id}-${subqchoice.questionpath}`,
            dc: !!subqchoice.dcdate
          }, isSubqchoice(subqchoice) && subqchoice.questionlabel, subMenu)) : /*#__PURE__*/React.createElement("div", {
            key: `checkbox-${subqchoice.parentquestionpath}-${subqchoice.id}-${subqchoice.questionpath}`,
            id: "read-only-select"
          }, /*#__PURE__*/React.createElement(StyledDiv, {
            key: `li-${subqchoice.id}-${subqchoice.questionpath}`,
            dc: !!subqchoice.dcdate,
            horizontal: subqchoice.drawmode === horizontal
          }, isSubqchoice(subqchoice) && getReadOnlySelectText(subqchoice, labelState), subMenu));
        }
      // FORMS components

      case statement:
        return /*#__PURE__*/React.createElement(ElementDiv, {
          key: `list-${subqchoice.id}`,
          id: "cpp-statement"
        }, /*#__PURE__*/React.createElement(FormLi, {
          key: `li-${subqchoice.id}`,
          id: "cpp-li-statement",
          horizontal: subqchoice.drawmode === horizontal,
          bullet: subqchoice.cssclass === 'bullet',
          readOnly: true
        }, /*#__PURE__*/React.createElement(ReadOnlyStatementField, {
          key: `field-${subqchoice.id}`,
          title: subqchoice.cssclass,
          text: subqchoice.questionlabel
        }), subMenu));

      case date:
        return /*#__PURE__*/React.createElement(ElementDiv, {
          key: `list-${subqchoice.id}`,
          id: "cpp-statement"
        }, /*#__PURE__*/React.createElement(FormLi, {
          key: `li-${subqchoice.id}`,
          id: "cpp-li-statement",
          horizontal: subqchoice.drawmode === horizontal,
          readOnly: true
        }, /*#__PURE__*/React.createElement(ReadOnlyStatementField, {
          key: `field-${subqchoice.id}`,
          text: `${formatLocDateMMDDYYYY(subqchoice.value)} (${subqchoice.questionlabel})`
        }), subMenu));

      case signature:
        return /*#__PURE__*/React.createElement("div", {
          key: `input-${subqchoice.id}-${subqchoice.questionpath}`,
          id: "read-only-input"
        }, /*#__PURE__*/React.createElement(FormSignature, {
          readOnly: true,
          subqchoice: subqchoice,
          handleValidate: undefined,
          handleClear: undefined
        }));

      case map:
        return /*#__PURE__*/React.createElement("div", {
          key: `input-${subqchoice.id}-${subqchoice.questionpath}`,
          id: "read-only-pain"
        }, /*#__PURE__*/React.createElement(PainMapReadOnly, {
          subqchoice: subqchoice
        }));
      // case checkbox, radio and null:

      default:
        {
          const {
            modifiedpersonfirstname,
            modifiedpersonlastname,
            modifiedpersoncredentials
          } = subqchoice;
          const credential = modifiedpersonfirstname && `${modifiedpersonfirstname} ${modifiedpersonlastname}, ${modifiedpersoncredentials}`;
          return /*#__PURE__*/React.createElement("div", {
            key: `checkbox-${subqchoice.parentquestionpath}-${subqchoice.id}-${subqchoice.questionpath}`,
            id: "read-only-default"
          }, /*#__PURE__*/React.createElement(StyledLi, {
            key: `li-${subqchoice.id}-${subqchoice.questionpath}`,
            dc: !!subqchoice.dcdate,
            noBullet: subqchoice.readonlydrawmode,
            horizontal: subqchoice.drawmode === horizontal && !subqchoice.readonlydrawmode
          }, /*#__PURE__*/React.createElement(React.Fragment, null, !subqchoice.readonlydrawmode && /*#__PURE__*/React.createElement(React.Fragment, null, isSubqchoice(subqchoice) && subqchoice.questionlabel), subqchoice.dcdate && /*#__PURE__*/React.createElement(DCDiv, null, /*#__PURE__*/React.createElement("div", null, subqchoice.questionlabel), /*#__PURE__*/React.createElement("div", null, credential ? `DC'd on ${subqchoice.dcdate} by
                  ${credential}` : `DC'd on ${subqchoice.dcdate}`))), subMenu));
        }
    }
  };

  const renderSubMenu = (subqchoices, depthLevel = 0, isHorizontal) => {
    const menuOptions = subqchoices.map(subqchoice => {
      const hasOptions = subqchoice.subqchoices && subqchoice.subqchoices.length > 0 && subqchoice.subqchoices[0] !== null;
      let subMenu;
      const isStatement = subqchoice.controltype === statement;
      const hasValue = depthLevel === 0 || isStatement ? true : isSubqchoice(subqchoice);
      const isHorizontalMode = subqchoice.drawmode === horizontal; // only render selected submenu and only if nested options exist

      if (hasValue && hasOptions) {
        const newDepthLevel = depthLevel + 1;
        const subChoices = subqchoice.subqchoices.filter(choice => choice.dcdate || choice.controltype === statement || choice.value !== 'false' && choice.value !== null);
        subMenu = renderSubMenu(subChoices, newDepthLevel, isHorizontalMode);
      }

      return renderField(subqchoice, subMenu);
    }); // TO KNOW The <ul> tag has a default padding-inline-start of 40px

    return /*#__PURE__*/React.createElement("div", {
      key: `div-key-${depthLevel}`
    }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(StyledReadOnlyUl, {
      id: "read-only-ul",
      horizontal: isHorizontal
    }, menuOptions)));
  };

  return /*#__PURE__*/React.createElement(FormBody, {
    id: "read-only",
    printView: printView,
    dialogHeight: dialogHeight
  }, title && /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    classes: printView ? {
      root: classes.printTitle
    } : {}
  }, title), /*#__PURE__*/React.createElement(Fragment, null, updatedData && updatedData[0] && renderSubMenu(updatedData), !updatedData && _ref), /*#__PURE__*/React.createElement(Fragment, null, pnNotes && renderTaggedNotes(pnNotes)));
};
export default ReadOnlyForm;